'use client';

/**
 * Forkast V2 logo: ромб-каркас с буквой F + текст ФОРКАСТ (RU) в Druk-style.
 * size — диаметр ромба в px, текст масштабируется автоматически.
 */
export function Logo({ size = 30, withText = true }: { size?: number; withText?: boolean }) {
  return (
    <div className="flex items-center gap-2">
      <div className="relative" style={{ width: size, height: size }}>
        <div
          className="absolute inset-0 bg-accent"
          style={{ transform: 'rotate(45deg)' }}
        />
        <div
          className="absolute bg-bg-base"
          style={{
            inset: size * 0.2,
            transform: 'rotate(45deg)',
          }}
        />
        <div
          className="absolute inset-0 flex items-center justify-center display text-accent"
          style={{ fontSize: size * 0.46 }}
        >
          F
        </div>
      </div>
      {withText && (
        <div
          className="display tracking-display-tight"
          style={{ fontSize: size * 0.66 }}
        >
          ФОРКАСТ
        </div>
      )}
    </div>
  );
}
